import { render, staticRenderFns } from "./ShopShowItem.vue?vue&type=template&id=c45aa77c&scoped=true&"
import script from "./ShopShowItem.vue?vue&type=script&lang=js&"
export * from "./ShopShowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45aa77c",
  null
  
)

export default component.exports